import React from "react";
import { observer } from "mobx-react";
import { computed, observable } from "mobx";
import { FieldRenderProps } from "react-final-form";
import { ValueType } from "react-select";

import AddIcon from "@material-ui/icons/Add";

import { Button, FormLabel } from "@material-ui/core";

import ContentStudioEquipmentStore from "stores/ContentStudioEquipmentStore";

import Popup from "components/Popup";
import withFieldControl from "components/FormControl/FieldControl";
import Placeholder from "components/Placeholder";

import EquipmentForm from "./EquipmentForm";
import EquipmentCard from "./EquipmentCard";

import { DictionaryItem } from "constants/models";

import {
  Container,
  ControlHeader,
  ControlContainer,
  Row,
  EquipmentsContainer,
} from "./styles";

type Props = {};

@observer
class EquipmentControl extends React.Component<FieldRenderProps<any> & Props> {
  @observable isPopupOpen: boolean = false;

  @computed
  get values() {
    const { input } = this.props;
    const value = input?.value || [];

    return value.map(
      ({
        id,
        title,
        imageUrl,
      }: {
        id: number;
        title: string;
        imageUrl: string;
      }) => ({ label: title, value: { id, imageUrl, title } }),
    );
  }

  @computed get filteredOptions() {
    return ContentStudioEquipmentStore.items
      .map(
        ({
          id,
          title,
          imageUrl,
        }: {
          id: number;
          title: string;
          imageUrl: string;
        }) => ({ label: title, value: { id, imageUrl, title } }),
      )
      .filter(
        option =>
          !this.values.find(({ value }) => value.id === option.value.id),
      );
  }

  onChange = (items: DictionaryItem[] = []) => {
    const {
      input: { onChange },
    } = this.props;

    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    onChange(event);
  };

  onRemoveItem = (option: ValueType<DictionaryItem>) => () => {
    const values = this.values.filter(
      item => item.value.id !== option.value.id,
    );
    this.onChange(values);
  };

  closePopup = () => {
    this.isPopupOpen = false;
  };

  openPopup = () => {
    this.isPopupOpen = true;
  };

  saveNewEquipment = (newEquipment: DictionaryItem[]) => {
    this.onChange([...this.values, ...newEquipment]);
    this.closePopup();
  };

  render() {
    return (
      <>
        {this.isPopupOpen && (
          <Popup
            onClose={this.closePopup}
            canCloseByOuterClick={false}
            withoutExitButton
          >
            <EquipmentForm
              options={this.filteredOptions}
              onClose={this.closePopup}
              onSave={this.saveNewEquipment}
            />
          </Popup>
        )}
        <Container>
          <Row>
            <ControlHeader>
              <FormLabel>Equipments</FormLabel>
              <ControlContainer>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<AddIcon />}
                  onClick={this.openPopup}
                >
                  Add Equipments
                </Button>
              </ControlContainer>
            </ControlHeader>
          </Row>

          {this.values.length ? (
            <Row>
              <EquipmentsContainer>
                {this.values.map(item => (
                  <EquipmentCard
                    key={item.value.id}
                    icon={item.value.imageUrl}
                    title={item.value.title}
                    onRemove={this.onRemoveItem(item)}
                    isEditMode
                  />
                ))}
              </EquipmentsContainer>
            </Row>
          ) : (
            <Placeholder
              height={132}
              width={132}
              text={"No equipment added yet."}
            />
          )}
        </Container>
      </>
    );
  }
}

export default withFieldControl(EquipmentControl);
